import React, { useState, useEffect } from "react";
import api from "../../api/axios.tsx";
import Input from "../ui/input.tsx";
import Label from "../ui/label.tsx";
import Button from "../ui/button.tsx";

type User = {
  id: string;
  user_name: string;
  email: string;
};

type Props = {
  onAdd: (name: string, email: string) => void;
};

export const AddFriendForm: React.FC<Props> = ({ onAdd }) => {
  const [emailQuery, setEmailQuery] = useState("");
  const [suggestions, setSuggestions] = useState<User[]>([]);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (emailQuery.length > 2) {
        api
          .get(`/users/search?query=${emailQuery}`)
          .then((res: any) => {
            setSuggestions(res.data);
          })
          .catch(() => setSuggestions([]));
      } else {
        setSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [emailQuery]);

  const handleSelect = (user: User) => {
    setSelectedUser(user);
    setEmailQuery(user.email); // or user.user_name if preferred
    setSuggestions([]);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedUser) return;
    onAdd(selectedUser.user_name, selectedUser.email);
    setSelectedUser(null);
    setEmailQuery("");
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4 relative">
      <div>
        <Label className="block mb-1">Connection's Email</Label>
        <Input
          type="text"
          value={emailQuery}
          onChange={(e) => {
            setEmailQuery(e.target.value);
            setSelectedUser(null);
          }}
          required
        />
        {suggestions.length > 0 && (
          <ul className="absolute z-10 bg-white border mt-1 rounded-md shadow w-full max-h-60 overflow-y-auto">
            {suggestions.map((user) => (
              <li
                key={user.id}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(user)}
              >
                <div className="font-medium">{user.user_name}</div>
                <div className="text-sm text-gray-500">{user.email}</div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="flex justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={() => {
            setEmailQuery("");
            setSelectedUser(null);
          }}
        >
          Cancel
        </Button>
        <Button type="submit" disabled={!selectedUser}>
          Send Request
        </Button>
      </div>
    </form>
  );
};
